import React, { useState } from "react";

import { Trash } from "lucide-react";

export default function GatewayCard({
  title,
  subtitle,
  icon,
  onDelete,
  onUpdate,
  g_status,
}) {
  const [isEnable, setIsEnable] = useState(g_status);
  return (
    <div className="bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl rounded-2xl border border-state-200/50 dark:border-slate-700/50 hover:shadow-xl hover:shadow-slate-900/20 p-4 transition-all duration-300 group">
      <div className="w-full flex items-center space-x-4">
        <img
          className="w-10 h-10 p-2 rounded-lg bg-slate-200/60 dark:bg-slate-800/60"
          src={icon}
          alt=""
        />

        <div className="flex flex-col">
          <h1 className="text-sm font-semibold text-black dark:text-slate-200">
            {title}
          </h1>
          <span className="text-xs font-medium text-slate-500 dark:text-slate-400">
            {subtitle}
          </span>
        </div>

        <div className="flex flex-col ml-auto items-center gap-2">
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={isEnable}
              onChange={(e) => {
                const value = e.target.checked;
                setIsEnable(value);
                onUpdate(value);
              }}
            />
            <div className="w-10 h-5 bg-gray-300 dark:bg-gray-700 rounded-full peer peer-checked:bg-blue-600 transition-all after:content-[''] after:absolute after:w-4 after:h-4 after:bg-white after:rounded-full after:top-[2px] after:left-[2px] peer-checked:after:translate-x-5 after:transition-all"></div>
          </label>

          <Trash
            onClick={() => onDelete?.()}
            className="w-6 h-6 text-red-500 cursor-pointer border border-slate-500/20 hover:border-red-500 p-1 rounded-md"
          />
        </div>
      </div>
    </div>
  );
}
